import Mic from '../../../../../Assets/StorefrontIcons/Mic.svg';
import Search from '../../../../../Assets/StorefrontIcons/Search.svg';

function SearchField() {
    return (
        <div className='px-4 select-none'>
            <div className="p-3 rounded-lg bg-[#232327] flex items-center gap-[10px]">
                <div className="w-[calc(100%-24px)] flex items-center gap-1">
                    <div className="size-6 flex items-center justify-center">
                        <img src={Search} alt="" />
                    </div>

                    <p className='w-[calc(100%-24px)] font-normal text-[12px] leading-6 text-[#B0B0B0]'>Search products</p>
                </div>

                <div className="size-6 flex items-center justify-center">
                    <img src={Mic} alt="" />
                </div>
            </div>
        </div>
    );
}

export default SearchField;
